import React from 'react'
// connect方法的作用：将额外的props传递给组件，并返回新的组件，组件在该过程中不会受到影响
import { connect } from 'react-redux'
// 引入action

import './index.css'
import { NetPost, NetGet } from '../../axios'
import { toast } from 'react-toastify'
import { Link } from "react-router-dom";
import BoardTop from '../board/boardTop';
import CodeBack from '../writeart/code-block'
import { runhtml } from '../../tool/runtime'
import { reSetBar } from '../../tool/reSetBar'
import Data from '../board/data'
const Editor = require('../writeart/editor')

// const CodeBack = require('../writeart/code-block')
// import { setPageTitle } from '../../store/actions.js'
const ReactMarkdown = require('react-markdown')


class Article extends React.PureComponent {
    state = {
        title: "",
        data: ""
    }
    locationID = this.props.history.location.search.replace(/[^\d]/g, "")


    // setTime=()=>{
    //     console.log(this.timer)
    //     if(this.timer){
    //         this.timer=false
    //         clearTimeout(this.timer)
    //     }else{
    //         this.timer=setTimeout(()=>{
    //             this.setState({
    //                 data:this.textarea.value
    //             })
    //         },2000)
    //     }

    // }
    componentDidMount() {
        reSetBar()
        this.node.scrollIntoView();
        this.getArt(this.locationID)
    }

    substringFun = (body) => {
        var imgmark = body.match(/!\[(.*?)\]\((.*?)\)/),
            newresult = body.substr(0, 500),
            index = 0

        const mapfun = () => {
            if (imgmark && imgmark.length > 0 && newresult.indexOf(imgmark[0]) < 0) {

                index += 1
                newresult = body.substr(0, 500 + index * 50)
                mapfun()
            } else {
                newresult = newresult.split("\n")
                if (newresult.length && newresult.length == 1) {
                    newresult = newresult.slice(0, newresult.length).join('\n')
                } else {
                    newresult = newresult.slice(0, newresult.length - 1).join('\n')
                }

            }
        }
        mapfun()
        return newresult
    }



    getArt = (id) => {
        NetGet("artartdetails", { id })
            .then((e) => {

                if (e.code == 0) {
                    try {
                        document.title = e.data.title
                        document.querySelector('meta[name="description"]').setAttribute('content', this.substringFun(e.data.body));
                        document.querySelector('meta[name="keywords"]').setAttribute('content', e.data.title);
                        
                    } catch (error) {
                        console.log(error)
                    }


                    this.setState({
                        ...e.data

                    })
                } else {
                    toast.error("文章获取失败 !");

                }
            })
            .catch(() => {
                toast.error("文章获取失败 !");

            })
    }


    onChange = (e) => {
        this.setState({
            data: e.target.value
        })
    }


    submit = () => {
        const inputV = this.input.value
        const textareaV = this.state.data
        const sort_nameV = "分类名字"
        if (!inputV || !textareaV || !sort_nameV) {
            return toast.error(`都必须填写!`);

        }
        let param = new URLSearchParams()
        param.append('title', inputV)

        param.append('body', textareaV)
        param.append('sort_name', sort_nameV)

        NetPost("addart", param)
            .then((e) => {
                if (e.code == 0) {

                    toast.success("文章发布成功 !");


                } else {
                    toast.error(`发布失败,后端错误 !`);

                }


            })
            .catch((e) => {

                toast.error("发布失败 !");
            })
    }
    rendertitle = (title, time, readnum) => {
        return (
            <header className="pattern-header single-header">
                <h1 className="entry-title">{title}</h1>
                <p className="entry-census">
                    <span>
                        <a >
                            <img src="https://q2.qlogo.cn/headimg_dl?dst_uin=839650216&spec=100" />
                        </a>
                    </span>
                    <span>
                        <a >Mi Manchi</a>
                    </span>
                    <span className="bull"> · </span>{time}<span className="bull"> · </span>{readnum} 次阅读


                    <a className="article-writer" href="/writer/article/"><i className="iconfont icon-write"></i>编辑文章</a>
                </p>
            </header>

        )
    }

    render() {
        const { body, title, time, readnum, posvimg } = this.state
        return (
            <div className="article-box " ref={node => this.node = node}>

                <BoardTop
                errimg={"https://cdn.jsdelivr.net/gh/A-ANing/manifest_s@master/myblog/images/onerr/98fca04416944b282a558b98b2131879.png"}
                    loadimg={"https://cdn.jsdelivr.net/gh/A-ANing/manifest_s@master/myblog/images/onloading/orange.progress-bar-stripe-loader.svg"}
                    bgimg={"https://cdn.jsdelivr.net/gh/A-ANing/manifest_s@master/myblog/images/bigimg/codebg.jpg"}
                    rendertitle={() => this.rendertitle(title, time, readnum)}
                    titlestyle={{ margin: "0 auto", display: "block", position: "absolute", top: "unset", bottom: "20px" }} />
                <section className="outer" >

                    <div className="article-mark mark-down" style={{ width: "100%" }}>

                        <ReactMarkdown
                            source={body}
                            escapeHtml={false}
                            skipHtml={false}
                            renderers={{ code: CodeBack }}

                        />
                    </div>
                    <Data articleid={this.locationID} dataname={"评论"}/>

                </section>
                {runhtml}
            </div>
        )
    }
}



export default connect()(Article)